export default __webpack_public_path__ + "static/media/img2.0e43baa7.jpg";